






















































































































































import {
  BARCODE_TYPE,
  CDKEY_SHOW_TYPE,
  CUSTOM_BUTTON_TYPE,
  getDisplayCouponDetail,
  IDisplayCouponDetail,
  TRANS_STATE_TYPE,
  useDisplayCoupon,
  IComponentDataType,
} from '@/api/displayCoupon/display-coupon';
import { showBusinessError, showDialog, hideDialog } from '@tencent/wphk-components-dialog';
import { hideLoading, showLoading } from '@tencent/wphk-components-loading';
import { FitIcon } from '@tencent/wphk-ui';
import debounce from '@/util/debounce';
import { util, windowHelper, elk, url, language, CustomException } from '@tencent/ppd-base-libs';
import { biHT } from '@/business/bi';
import Vue from 'vue';
import {
  formattedDiffTime,
  getPage1BtnBottomText,
  getPage1BtnText,
  getPage1BtnTopText,
  isCdkeyCoupon,
  isExpired,
  isNeedCountdown,
  isNoCdkeyCoupon,
  isNotStart,
  isPage1BtnInvalid,
  isShowPage1BtnBottomText,
  isShowPage1BtnTopText,
  isShowStep2,
  isUsed,
  isVisitedPage2,
  isShowStep2Btn,
  getStep2BtnText,
  getStep2TopText,
  isShowWechatIcon,
  getStep2BtnUrl,
  isShowStep1Title,
  getStep1TitleText,
  isShowCopy,
  markVisitedPage2,
  getConfirmModalText,
  getPage1PageType,
  isMarkUseCoupon,
  isLaunchCustomWeApp,
  getWeAppFormHref,
} from '../business/display-coupon-record';
import CouponInfoCard from '../components/display-coupon-detail/coupon-info-card.vue';
import { i18n } from '@/i18n';
import { loadMarkUseWhitelistCfg } from '../api/displayCoupon/display-coupon';
import CDKeyCode from '@/components/display-coupon-detail/cdkey-code.vue';
import  { jumpScanpay, QrpayFromScene } from '@tencent/wphk-components-jump-page';
import { copy } from '@tencent/wphk-components-copy';

import {
  getCountDownDiffTime,
  getFormattedDate,
  getFormattedDateAndTime,
  getServerTime,
  TEN_MIN,
} from '../util/dateHelper';
import { LanuchWeapp } from '@tencent/wphk-components-launch-weapp';
import { parseHK$Aria } from '@tencent/wphk-act-base-ui';
import { biClick } from '@tencent/fit-bi-sdk';


export default Vue.extend({
  name: 'displaycoupondetail',
  components: {
    FitIcon,
    CouponInfoCard,
    LanuchWeapp,
    CDKeyCode,
  },
  data(): IComponentDataType {
    return {
      couponDetail: (undefined as unknown) as IDisplayCouponDetail,
      userScid: '',
      currentDate: getServerTime(), // TODO 获取服务器时间
      countDownTime: '',
      countDownInterval: 0,
      diffTime: 0,
      isShowPage2: false,
      isShowCond: true,
      isShowCondBtn: false,
      miniProgramUrl: '',
      lang: language.getLanguage(),
    };
  },

  computed: {
    /** 点击自定义跳转按钮是否跳转小程序 */
    isLaunchCustomWeApp(): boolean {
      if (!this.couponDetail) {
        return false;
      }
      return isLaunchCustomWeApp(this.couponDetail);
    },
    /** 跳转目标小程序的基本信息 */
    customWeAppInfo(): null | ReturnType<typeof getWeAppFormHref> {
      if (!this.couponDetail) {
        return null;
      }
      if (!isLaunchCustomWeApp(this.couponDetail)) {
        return null;
      }
      return getWeAppFormHref(this.couponDetail.jumpUrl);
    },
  },
  async created() {
    document.title = i18n('商戶電子優惠券');
    this.userScid = this.getUserScid();
    // 绑定debounce
    this.showConfirmUseModal = debounce(this.showConfirmUseModal);
    this.onClickCustomBtn = debounce(this.onClickCustomBtn);
    document.addEventListener('visibilitychange', this.onPageVisiblilityChange);
    await loadMarkUseWhitelistCfg();
    await this.getDisplayCouponDetail();

    // 如果已进入过page2，且（该券未过期且未使用，或者(已使用但是在倒计时)）
    // 判斷是否訪問過第二頁
    if (
      isVisitedPage2(this.couponDetail)
      && ((!isExpired(this.couponDetail) && !isUsed(this.couponDetail))
        || (isUsed(this.couponDetail) && this.isCountDowning()))
    ) {
      this.isShowPage2 = true;
      this.isShowCond = false;
      this.isShowCondBtn = true;
      biHT('promotion.merchantcoupon.coupondetails.page_brow', {
        btntype: this.couponDetail.customBtnType,
        type: this.isCountDowning() ? '1' : '2',
        pagetype: getPage1PageType(this.couponDetail),
      });
    } else {
      biHT('promotion.merchantcoupon.tousecoupondetails.page_brow', {
        btntype: this.couponDetail.customBtnType,
      });
    }
  },
  beforeDestroy() {
    this.stopCountDown();
    hideDialog();
    document.removeEventListener(
      'visibilitychange',
      this.onPageVisiblilityChange,
    );
  },
  methods: {
    i18n,
    getFormattedDate,
    getFormattedDateAndTime,
    isShowPage1BtnTopText,
    getPage1BtnTopText,
    isPage1BtnInvalid,
    getPage1BtnText,
    isShowPage1BtnBottomText,
    getPage1BtnBottomText,
    isNotStart,
    isShowStep2,
    isShowStep2Btn,
    getStep2BtnText,
    getStep2TopText,
    isShowWechatIcon,
    isShowStep1Title,
    getStep2BtnUrl,
    getStep1TitleText,
    isShowCopy,
    isMarkUseCoupon,
    parseHK$Aria,
    onClickCopy() {
      copy({ text: this.couponDetail.spCdkey }, this.lang);
    },
    getBaseInfoClass() {
      if (this.isCountDowning() || this.isShowPage2) {
        return '';
      }
      if (isNotStart(this.couponDetail)) {
        return 'notStart';
      }
      if (isUsed(this.couponDetail) || isExpired(this.couponDetail)) {
        return 'usedOrExpired';
      }
      return '';
    },
    getUserScid() {
      return url.getUrlHash('userScid') || url.getUrlParam('userScid');
    },
    stopCountDown() {
      if (this.countDownInterval !== 0) {
        clearInterval(this.countDownInterval);
        this.countDownInterval = 0;
      }
    },
    onPageVisiblilityChange() {
      if (!document.hidden && this.isCountDowning()) {
        this.getDisplayCouponDetail();
      }
    },
    onClickShowCond() {
      biHT('promotion.merchantcoupon.coupondetails.usedetail_click');
      this.isShowCond = true;
      this.isShowCondBtn = false;
    },
    isCdkeyCoupon() {
      return isCdkeyCoupon(this.couponDetail.couponType);
    },
    isNoCdkeyCoupon() {
      return isNoCdkeyCoupon(this.couponDetail.couponType);
    },
    isShowCdkeyCodeOnly() {
      return CDKEY_SHOW_TYPE.CODE === this.couponDetail.spCdkeyShow;
    },
    isCountDowning() {
      return this.diffTime > 0;
    },
    initCountDown() {
      if (!isNeedCountdown(this.couponDetail) || !isUsed(this.couponDetail)) {
        return;
      }
      // 如果有进行中的倒计时，先停掉
      this.stopCountDown();
      // 先获取服务器当前时间
      // this.currentDate = getServerTime();
      // const stopCountDownTime = moment(String(this.couponDetail.useTime) || '').add('10', 'minute');
      const tmpDiffTime = getCountDownDiffTime(this.couponDetail.useTime);
      if (tmpDiffTime > 0) {
        this.diffTime = tmpDiffTime;
        this.countDownInterval = setInterval(() => {
          this.diffTime = Math.max(this.diffTime - 1000, 0);
          if (this.diffTime <= 0) {
            this.isShowPage2 = false;
            this.isShowCond = true;
            this.isShowCondBtn = false;
          }
        }, 1000);
      }
      // if (
      //   moment(this.currentDate).isBefore(stopCountDownTime)
      // ) {
      //   this.diffTime = stopCountDownTime.diff(this.currentDate);
      //   this.countDownInterval = setInterval(() => {
      //     this.diffTime = Math.max(this.diffTime - 1000, 0);
      //     if (this.diffTime <= 0) {
      //       this.isShowPage2 = false;
      //       this.isShowCond =  true;
      //       this.isShowCondBtn = false;
      //     }
      //   }, 1000);
      // }
    },
    getFormattedDiffTime() {
      return formattedDiffTime(this.diffTime);
    },
    async getDisplayCouponDetail() {
      showLoading();
      const [err, res] = await util.to(getDisplayCouponDetail({
        user_scid: this.userScid,
      }));
      hideLoading();
      if (err) {
        showBusinessError(err);
        throw new Error(err);
      }
      if (res) {
        this.couponDetail = res;
        this.initCountDown();
        this.miniProgramUrl = `cdkey=${encodeURIComponent(this.couponDetail.spCdkey)}&barcodeType=${this.couponDetail.barcodeType || BARCODE_TYPE.code128}&cdkeyShow=${this.couponDetail.spCdkeyShow}&userScid=${
          this.userScid
        }`;
        // console.log('miniProm barcodeType', this.couponDetail.barcodeType, this.miniProgramUrl);
        if (this.isShowMiniProgram()) {
          biHT('promotion.merchantcoupon.coupondetails.cantscan_brow');
        }
      }
    },
    onClickCustomBtn() {
      const targetUrl = getStep2BtnUrl(this.couponDetail);
      // 需要更新埋點
      if (this.couponDetail.customBtnType === CUSTOM_BUTTON_TYPE.PAYMENT) {
        biHT('promotion.merchantcoupon.coupondetails.pay_click');
        this.jumpScanpay(targetUrl);
        return;
      }
      if (this.isLaunchCustomWeApp && this.customWeAppInfo) {
        return biHT('promotion.merchantcoupon.coupondetails.weapp_click', {
          url: targetUrl,
        });
      }
      if (
        this.couponDetail.customBtnType === CUSTOM_BUTTON_TYPE.CUSTOMIZE
      ) {
        biClick('coupondetails.url_click', {
          furl: targetUrl || '',
        });
      }
      if (targetUrl) {
        windowHelper.redirect(targetUrl, 300);
      } else {
        new CustomException({
          targetUrl,
          couponInfo: this.couponDetail,
        }, 'jumpTargetUrlError', '商户展示券跳转链接或者小程序失败，请检查配置');
      }
    },
    /**
     * 拉起原生支付
     * @param url 拉起原生刷卡失败后的兜底h5刷卡访问地址
     */
    async jumpScanpay(url = '') {
      const [err] = await util.to(jumpScanpay(url, 'display-coupon', { scene: QrpayFromScene.HKLife }));
      if (err) {
        const errMsg = err.retmsg
        || err.message
        || err.toString()
        || i18n('系統繁忙，請稍候再試。');
        showDialog({
          content: errMsg,
          btns: [
            {
              text: i18n('我知道了'),
            },
          ],
        });
      }
    },
    /** 标记为已打开，仅针对无倒计时的展示券 */
    async markOpenState() {
      showLoading();
      const [err, res] = await util.to(markVisitedPage2(this.userScid));
      hideLoading();
      if (err) {
        showBusinessError(err);
        throw '打开商户优惠券失败';
      }
      console.log(res);
    },
    goToPage2() {
      this.isShowPage2 = true;
      this.isShowCond = false;
      this.isShowCondBtn = true;
    },
    goToPage1() {
      this.isShowPage2 = false;
      this.isShowCond = true;
      this.isShowCondBtn = false;
    },
    async showConfirmUseModal() {
      // 如果按鈕不能用，則直接return
      if (isPage1BtnInvalid(this.couponDetail)) {
        return;
      }
      if (!isNeedCountdown(this.couponDetail)) {
        biHT('promotion.merchantcoupon.tousecoupondetails.use_click', {
          btntype: this.couponDetail.customBtnType,
        });
        await this.markOpenState();
        this.goToPage2();
        return;
      }
      biHT('promotion.merchantcoupon.tousecoupondetails.use_click', {
        btntype: this.couponDetail.customBtnType,
      });
      const { title, htmlContent } = getConfirmModalText(this.couponDetail);
      showDialog({
        title,
        htmlContent,
        btns: [
          {
            click: () => {
              biHT('promotion.merchantcoupon.tousecoupondetails.cancel_use_click');
              hideDialog();
            },
            text: i18n('取消'),
          },
          {
            click: debounce(async () => {
              biHT('promotion.merchantcoupon.tousecoupondetails.confirm_use_click');
              hideDialog();
              await this.useCoupon();
              // this.goToPage2();
            }),
            text: i18n('確定使用'),
          },
        ],
      });
    },

    async onClickMarkUse() {
      // 要不要判斷是否展示
      showDialog({
        content: i18n('該優惠已使用，請按“確認”更新。'),
        btns: [
          {
            click: () => {
              hideDialog();
            },
            text: i18n('取消'),
          },
          {
            click: debounce(() => {
              hideDialog();
              this.onConfirmMarkUse();
            }),
            text: i18n('確認'),
          },
        ],
      });
    },
    async onConfirmMarkUse() {
      showLoading();
      const [err, res] = await util.to(useDisplayCoupon({
        user_scid: this.userScid,
        cmd: 'used',
      }));
      hideLoading();
      if (err) {
        showBusinessError(err);
        throw new Error(err);
      }
      if (res) {
        this.couponDetail.transState = TRANS_STATE_TYPE.USED; // 设置成已使用
        this.couponDetail.useTime = res.useTime;
        // 为了保证付款链接的时效性，这里会更新生成付款链接
        this.couponDetail.businessId = res.businessId;
        this.couponDetail.jumpPackage = res.jumpPackage;
        // 已使用是page1
        this.goToPage1();
      }
    },
    async useCoupon() {
      showLoading();
      const [err, res] = await util.to(useDisplayCoupon({
        user_scid: this.userScid,
      }));
      hideLoading();
      if (err) {
        showBusinessError(err);
        throw new Error(err);
      }
      if (res) {
        this.couponDetail.transState = TRANS_STATE_TYPE.USED; // 设置成已使用
        this.couponDetail.useTime = res.useTime;
        // 为了保证付款链接的时效性，这里会更新生成付款链接
        this.couponDetail.businessId = res.businessId;
        this.couponDetail.jumpPackage = res.jumpPackage;
        // this.initCountDown();
        //  const tmpDiffTime = getCountDownDiffTime(this.couponDetail.useTime);
        // if (tmpDiffTime > 0) {
        this.diffTime = TEN_MIN;
        this.countDownInterval = setInterval(() => {
          this.diffTime = Math.max(this.diffTime - 1000, 0);
          if (this.diffTime <= 0) {
            this.isShowPage2 = false;
            this.isShowCond = true;
            this.isShowCondBtn = false;
          }
        }, 1000);
        // }
        this.goToPage2();
      }
    },
    gotoMiniProgram() {
      biHT('promotion.merchantcoupon.coupondetails.cantscan_click');
      elk({
        key: 'spCouponMiniProgramClick',
        msg: JSON.stringify({
          cdkey: this.couponDetail.spCdkey,
          cdkeyShow: this.couponDetail.spCdkeyShow,
          userScid: this.userScid,
        }),
      });
    },
    isShowMiniProgram() {
      // 商户展示券（有CDKey）的、且跳转按钮为“前往付款”、且券码类型为“非券码”类型的全部展示券，在条形码/二维码下方增加“小程序码”入口
      return (
        this.isCdkeyCoupon()
        && this.couponDetail.customBtnType === CUSTOM_BUTTON_TYPE.PAYMENT
        && !this.isShowCdkeyCodeOnly()
      );
    },
  },
});
